import DepsService from 'services/dependencies';

const CONTEXT = 'captcha';

export const setCaptcha = async (callback) => {
  const url = DepsService.rest.captcha.siteKey.url;
  const queryParams = {};
  const urlParams = {};

  const data = await DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
  grecaptcha.render('reCaptchaContainer', {
    'sitekey': data,
    callback,
  });
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-captcha/resources/rw-captcha.api.js